import type { Metric } from '@dialogue/active-minutes'

export const cleanupMetric = (metric: number | string, challengeMetric: Metric): string => {
  const value = challengeMetric !== 'steps' ? Number(metric) / 1000 : Number(metric)

  let fixedMetric: number | string = +parseFloat(String(value)).toFixed(2)
  const decimals = fixedMetric.toString().split('.')[1]

  if (decimals && decimals.length === 1) {
    fixedMetric = `${fixedMetric}0`
  }

  return fixedMetric.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
